<script>
    import Fa from "svelte-fa";
    import {faCircleQuestion} from "@fortawesome/free-solid-svg-icons";

    export let url;
</script>

{#if url}
    <a href="{url}" target="_blank" rel="noreferrer" {...$$restProps} class="avoid-line-break">
        <Fa icon={faCircleQuestion} /> Hilfe
    </a>
{/if}

<style>
    a {
        color: var(--brak-dark-blue);
        text-decoration: none;
        font-weight: bold;
    }

    a :global(svg) {
        font-size: 20px;
    }
</style>